import React from 'react'

const MemberLeft = ({leftinfo}) => {
  return (
    <div className='mem-left'>
        {leftinfo.image && <img src={leftinfo.image} alt="" className='profile'/>}
        <div className="mem-infos">
            <div className="mem-name">
                <h1>{leftinfo.name}</h1>
                <p>{leftinfo.course}</p>
            </div>
            <p className='position'>{leftinfo.position}</p>
            <p className='college'>{leftinfo.college}</p>
            <div className="socials">
                <a href={leftinfo.instagram}><img src="./Assets/instagram.png" alt="" className='social-icon' /></a>
                <a href={leftinfo.linkedin}><img src="./Assets/linkedin.png" alt="" className='social-icon' /></a>
                <a href={leftinfo.whatsapp}><img src="./Assets/whatsapp.png" alt="" className='social-icon' /></a>
            </div>
        </div>
    </div>
  )
}

export default MemberLeft;